export default __webpack_public_path__ + "static/artistBox-lyko-lianna-6bf4e9c794785b06efee3d04a19c8967.png";